import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.172 3.464a2 2 0 0 1 .496 1.318l-.004.132a2 2 0 0 1-.582 1.282l-2.929 2.929h-1.88A2 2 0 0 0 7.8 12.478l-.776.775-.113.107a2.55 2.55 0 0 1-2.961.303l-.81.809-.064.055a.667.667 0 0 1-.88-.998l.81-.81a2.55 2.55 0 0 1-.339-1.27l.005-.156a2.55 2.55 0 0 1 .743-1.649l4.976-4.976-1.057-1.057L5.14 5.805l-.063.056a.667.667 0 0 1-.88-.998l2.667-2.667.063-.055a.67.67 0 0 1 .88.055l1.528 1.528 1.138-1.137.096-.091a2 2 0 0 1 2.734.09l.78.781zm-.975 1.723a.67.67 0 0 0-.058-.877l-.78-.78-.067-.059a.67.67 0 0 0-.406-.138l-.087.007a.67.67 0 0 0-.384.19l-1.137 1.137L12 6.391l1.138-1.138z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9.449 11.2h3.935",
      style: {"stroke-opacity":".4"}
    }, null, -1)
  ])))
}
export default { render: render }